export const getBrowserName = () => {
  const ua = navigator.userAgent
  if (/Kindle|Silk|KFTT|KFOT|KFJWA|KFJWI|KFSOWI|KFTHWA|KFTHWI|KFAPWA|KFAPW/i.test(ua)) {
    return 'Kindle Browser'
  }

  if (ua.includes('Opera') || ua.includes('OPR')) {
    return 'Opera'
  }

  if (ua.includes('Chrome') || ua.includes('CriOS')) {
    return 'Google Chrome'
  }

  if (ua.includes('Safari')) {
    return 'Apple Safari'
  }
  if (ua.includes('Firefox')) {
    return 'Mozilla Firefox'
  }
  if (ua.includes('MSIE' || ua.includes('Trident'))) {
    return 'Microsoft Internet Explorer'
  }
  return 'Unknown'
}

export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|Silk|IEMobile|Opera Mini/i.test(navigator.userAgent)

export const isIphone = () => /iPhone/i.test(navigator.userAgent)
